const SOLO_TEAM_VALUE = 'solo' as const

export type SelectedTeamComputation = {
  readonly cookieValue: string
  readonly selectedTeamId: string | null
  readonly isSolo: boolean
}

export type ComputeSelectedTeamOptions = {
  readonly fallbackToSolo?: boolean
}

export const computeSelectedTeamState = (
  raw: string | null | undefined,
  options?: ComputeSelectedTeamOptions,
): SelectedTeamComputation => {
  const trimmed = raw?.trim()
  if (!trimmed) {
    if (options?.fallbackToSolo) {
      return {
        cookieValue: SOLO_TEAM_VALUE,
        selectedTeamId: null,
        isSolo: true,
      }
    }
    return {
      cookieValue: SOLO_TEAM_VALUE,
      selectedTeamId: null,
      isSolo: false,
    }
  }

  if (trimmed === SOLO_TEAM_VALUE) {
    return {
      cookieValue: SOLO_TEAM_VALUE,
      selectedTeamId: null,
      isSolo: true,
    }
  }

  return {
    cookieValue: trimmed,
    selectedTeamId: trimmed,
    isSolo: false,
  }
}

export const SOLO_TEAM_COOKIE_VALUE = SOLO_TEAM_VALUE
